// src/components/Loading.js
import React from 'react';
import '../assets/styles/Loading.css'; // Importa os estilos
import logo32 from '../assets/images/logo32.png'; // Importa a imagem

const Loading = () => {
    return (
        <div className="loading-container">
            <img src={logo32} alt="Loading..." className="loader" /> {/* Usa a imagem como loader */} 
        </div>
    );
};

export default Loading;